import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { ReportFragment, REPORT_FRAGMENT } from "../../fragments";
import { ReportsQueryVariables } from "../../types";

export const GET_REPORTS = gql`
  query getReports(
    $page: Int
    $per: Int
    $createdAfter: String
    $madId: ID
    $lastCheckedAt: String
    $campaignId: ID
  ) {
    reports(
      page: $page
      per: $per
      createdAfter: $createdAfter
      madId: $madId
      lastCheckedAt: $lastCheckedAt
      campaignId: $campaignId
    ) {
      collection {
        ...ReportFragment
      }
      metadata {
        totalCount
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export type ReportsData = { reports: { collection: ReportFragment[] } };

export default (
  options?: QueryHookOptions<ReportsData, ReportsQueryVariables>
) => {
  return useQuery<ReportsData, ReportsQueryVariables>(GET_REPORTS, options);
};
